import styles from "./style.module.scss";

interface StageCardProps {
  content: React.ReactNode;
}
export default function StageCard({ content }: StageCardProps) {
  return <div className={styles.wrapper}>{content}</div>;
}
